
import React from "react";
import { Label } from "@/components/ui/label";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface House {
  id: string;
  name: string;
}

interface HouseSelectorProps {
  houses: House[];
  selectedHouse: string;
  setSelectedHouse: (houseId: string) => void;
}

export const HouseSelector = ({ 
  houses, 
  selectedHouse, 
  setSelectedHouse 
}: HouseSelectorProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="house">Seleccionar Casa</Label>
      <Select value={selectedHouse} onValueChange={setSelectedHouse}>
        <SelectTrigger id="house" className="bg-white">
          <SelectValue placeholder="Seleccione una casa" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          {houses.map((house) => (
            <SelectItem key={house.id} value={house.id}>
              {house.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
